import { render, staticRenderFns } from "./SlideTitleSettings.vue?vue&type=template&id=c7ab3fd6&scoped=true&"
import script from "./SlideTitleSettings.vue?vue&type=script&lang=js&"
export * from "./SlideTitleSettings.vue?vue&type=script&lang=js&"
import style0 from "./SlideTitleSettings.vue?vue&type=style&index=0&id=c7ab3fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ab3fd6",
  null
  
)

export default component.exports